import styled from 'styled-components';
import { Flex, RestrictedIndicator } from '@elementary/common-ui/components';

const Card = styled(Flex)`
  align-items: center;
  padding: 12px 16px;
  background: ${({ theme }) => theme.palette.common.gray3};
  border: 1px dashed ${({ theme }) => theme.palette.common.gray5};
  border-radius: 4px;
`;

const IncidentRestrictedMonitorCard = () => (
  <Card>
    <RestrictedIndicator />
  </Card>
);

export default IncidentRestrictedMonitorCard;
